export default {
  tabela: {
    nome: 'Nome',
    modulo: 'Modulo',
    url: 'URL',
  },
  titulo_modal: 'Endpoint(s)',
};
